/**
 * Helpers for reading the provider name a round recorded.
 *
 * A round stores the vendors available to it joined with `+`, or `offline` when
 * the deployment has no map key. The value is a string rather than a union so
 * that adding a vendor needs neither a migration nor a client release, which
 * means every consumer must go through these two questions instead of comparing
 * the whole value.
 */

/** Whether a stored provider name says the round used synthesized data. */
export function isOfflineProviderName(name: string | null | undefined): boolean {
  return (name ?? '').split('+').includes('offline')
}

/**
 * Whether a stored provider name owes the Tianditu attribution.
 *
 * Tianditu's licence requires any surface showing its content to credit
 * 天地图, so the check follows the same `+` joined shape.
 */
export function usesTianditu(name: string | null | undefined): boolean {
  return (name ?? '').split('+').includes('tianditu')
}
